// extracted by mini-css-extract-plugin
export default {"container":"styles_container__haFv1","upgradeTo":"styles_upgradeTo__XuzV3","upgradeButton":"styles_upgradeButton__kDEpn"};